import { IncomeItemService } from "./../../../services/catalogs/IncomeItemService";
import React from "react";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { ExpenseItemDetail } from "../../../components/Pages/Catalogs/ExpenseItem/ExpenseItemDetail";
import { CreateExpenseItemDto } from "../../../dtos/catalogs/ExpenseItem/CreateExpenseItemDto";
import { IncomeItemDetail } from "../../../components/Pages/Catalogs/IncomeItem/IncomeItemDetail";

import { CreateIncomeItemDto } from "../../../dtos/catalogs/IncomeItem/CreateIncomeItemDto";
import { NFLookupIncomeItem } from "../../../components/Shared/NewForms/NFLookupIncomeItem";
import IncomeItemList from "../../../components/Pages/Catalogs/IncomeItem/IncomeItemList";

export const IncomeItem: IAppEntity = {
  entityType: "catalog",
  title: "Income Item",
  pluralTitle: "Income Item",
  apiUrl: "IncomeItems",
  apiEnum: ReferenceTypes.CatalogExpenseItem,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(IncomeItemDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(IncomeItemList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupIncomeItem, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new IncomeItemService("IncomeItems"),
  getEmptyModel: () => {
    const model: CreateIncomeItemDto = {
      name: "",
      createdDate: new Date(),
    };
    return model;
  },
};
